import { createReducer, on } from '@ngrx/store';
import { AssessmentState } from '../assessment.state';
import * as AssessmentActions from './assessment.actions';
import { state } from '@angular/animations';

// Initial state when app loads
export const initialState: AssessmentState = {
  student: null,
  selectedDomain: null,
  selectedSubDomain: null,
  selectLearningOutcome : [],
  loading: false,
  error: null,
};

// Reducer function handles all actions
export const assessmentReducer = createReducer(
  initialState,

  // Handle student selection
  on(AssessmentActions.selectStudent, (state, { id, name, age }) => ({
    ...state, // Spread existing state
    student: { id, name, age }, //Set new student
    selectedDomain: null, // Reset domain (fresh assessment)
    selectedSubDomain: null,
  })),

  // Handle domain selection
  on(AssessmentActions.selectDomain, (state, { domain }) => ({
    ...state,
    selectedDomain: domain, // Save selected domain
    selectedSubDomain: null, // Reset subdomain
  })),

  // Handle subdomain selection
  on(AssessmentActions.selectSubDomain, (state, { subDomain }) => ({
    ...state,
    selectedSubDomain: subDomain, // Save selected subdomain
  })),

  on(AssessmentActions.selectLearningOutcome, (state, { outcomes }) => ({
    ...state,
    selectLearningOutcome: outcomes,
  })),

  // Reset everything
  on(AssessmentActions.resetAssessment, () => initialState),

  // Set loading state
  on(AssessmentActions.setLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),

  // Set error
  on(AssessmentActions.setError, (state, { error }) => ({
    ...state,
    error,
  }))
);
